<template>
  <table v-if="dataArr && dataArr.length" class="table">
    <tr>
      <td v-for="item in dataArr" :colspan="item.children.length" :class="{ultimate: !(item.children && item.children.length), single: item.children.length==0}" :data-obj="objToStr(item)">
        {{ item.name }}
        <children :dataArr="item.children"></children>
      </td>
    </tr>
    <slot></slot>
  </table>
</template>

<script>
export default {
  name: 'children',
  data () {
    return {}
  },
  props: ['dataArr', 'dataObj'],
  methods: {
    objToStr(obj) {
      /*
      if(!obj.dynamicForm) {
        if(obj.type == 'TEXT' && this.isHasFormFieldValue(obj.field)) {
          obj.defaultValue = this.getFormFieldValue(obj.field)
        }
        if(obj.type == 'TEXT' && !this.isHasFormFieldValue(obj.field)) {
          obj.defaultValue = ''
        }
        if(obj.type == 'SELECT') {
          obj.fieldOptions = this.getFormFieldValue(obj.fieldName)
        }

      }
      return obj.children && obj.children.length ? '' : JSON.stringify(obj);
      */
    },
    //判断是否有值
    isHasFormFieldValue(name) {
     /* if(this.dataObj.hasOwnProperty(name)) {
        return true
      }else {
        return false
      }*/
    },
    //获取非动态字段默认值/下拉列表
    getFormFieldValue(name) {
      /*if(this.dataObj.fieldOptions(name)) {
        return this.dataObj[name]
      }*/
    }
  }
}
</script>
<style lang="less" scoped>
  .table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    margin-top: 10px;
    td {
      border: 1px solid #e5e5e5;
      background-color: #ffffff;
      padding-top: 10px;
    }
    .ultimate {
      border-top: 1px solid #e5e5e5;
      background-color: #ffffff;
      padding: 5px;
      border-left: none;
      border-bottom: none;
      border-right: none;
    }
    .single {
      border-left: 1px solid #e5e5e5;
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// ./src/components/children.vue